import { AxiosInstance, AxiosResponse } from 'axios'

import { ValidationRegisterRequest } from 'src/models/interface/validtionRegister'

export const registerValidationClient = (httpInstance: AxiosInstance) => ({
  putValidationRegister: async (id: string): Promise<AxiosResponse> => {
    const url = `${process.env.NEXT_PUBLIC_API_PORTAL_CLIENT}/validacao-contato/validar-link?id=${id}`
    return await httpInstance.put(url)
  },

  putResendCode: async (id: string): Promise<AxiosResponse> => {
    const url = `${process.env.NEXT_PUBLIC_API_PORTAL_CLIENT}/validacao-contato/reenviar-codigo?id=${id}`
    return await httpInstance.put(url)
  },

  postValidationRegister: async (validationRegister: ValidationRegisterRequest): Promise<AxiosResponse> => {
    const url = `${process.env.NEXT_PUBLIC_API_PORTAL_CLIENT}/validacao-contato/confirmar`
    return await httpInstance.post(url, validationRegister)
  }
})
